module.exports = __webpack_public_path__ + "static/img/kc1.1b8c4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/kc1.png
// module id = 2xX6
// module chunks = 1